import React, { useEffect } from 'react';
import { DateTime } from 'luxon';

import { Layout, Link, ProductImg, Text } from 'ds';
import { FURNITURE_PATH } from 'routes';

import OrderProgressBar from './OrderProgressBar';
import { FurnitureOrderWidgetData } from './types';
import { formatDeliveryDate } from './utils';

interface Props {
  data: FurnitureOrderWidgetData;
}

let animateProgressBar = true;

const FurnitureOrderWidget: React.FC<Props> = ({ data: { id, delivery_date, image, description, status } }) => {
  const deliveryDate = delivery_date
    ? formatDeliveryDate({ date: delivery_date, format: { month: 'short', day: 'numeric' } })
    : null;

  const arrivingToday = delivery_date
    ? DateTime.fromISO(delivery_date).startOf('day').equals(DateTime.now().startOf('day'))
    : false;

  const progressPercent = arrivingToday
    ? 90
    : {
        pending: 10,
        scheduled: 50,
        completed: 100
      }[status];

  useEffect(() => {
    setTimeout(() => {
      animateProgressBar = false;
    }, 1000);
  }, []);

  return (
    <Link href={`${FURNITURE_PATH}/orders`} search={`order_id=${id}`} color="black" fullWidth fullHeight>
      <Layout
        borderRadius={16}
        color="gray-25"
        paddingLeft={12}
        paddingRight={20}
        align="center"
        gap={16}
        height="100%"
      >
        <ProductImg
          srcKey={image?.key}
          size="thumbnail"
          alt={description}
          style={{ width: 56, height: 56, borderRadius: 8, backgroundColor: 'white' }}
        />
        <Layout direction="column" gap={4} flexGrow={1}>
          <Text size="body-xs">Furniture order</Text>
          <OrderProgressBar progressPercent={progressPercent} animate={animateProgressBar} />
          <Text size="body-xs" color="gray-400">
            {deliveryDate}
          </Text>
        </Layout>
      </Layout>
    </Link>
  );
};

export default FurnitureOrderWidget;
